var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button navigation",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"icon arrow-back"}),_vm._v(" "),_c('span',{staticClass:"hide-android"},[_vm._t("default",function(){return [_vm._v("Terug")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }